import EventNew from './EventNew';

export default EventNew;
